/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import { useFormik } from 'formik';

import { useSnackbar } from 'notistack';
import PartnerForm from '../../components/partnermng/PartnerForm';
import client from '../../lib/api/client';
import { useDispatch, useSelector } from 'react-redux';
import { setPartner } from '../../modules/partnerModule/partner';
import { publishPartnerCreated } from '../../utils/partnerCreatedEvent';

const PartnerFormContainer = ({ type }) => {
  let navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  // 2026-10-22 B3(ksm_frontend PartnerAddContainer.js에서 포팅): 기회/프로젝트 폼에서
  // "거래처 등록"으로 새 탭을 열었을 때만 returnTo/returnToken이 붙어 온다.
  const returnParams = new URLSearchParams(location.search);
  const returnTo = returnParams.get('returnTo') || '';
  const returnToken = returnParams.get('returnToken') || '';
  const shouldReturnToProjectForm = type === 'add' && returnTo === 'projectForm' && returnToken;

  const { partner } = useSelector(({ partnerModule }) => ({
    partner: partnerModule.partner.partner,
  }));

  let initialValues = {
    partnerTyp:
      partner && partner.partnerTyp !== null ? partner.partnerTyp : '',
    partnerCd:
      partner && partner.partnerCd !== null ? partner.partnerCd : '',
      
    incTyp: partner && partner.incTyp !== null ? partner.incTyp : '',
    //tradeTyp: partner && partner.tradeTyp !== null ? partner.tradeTyp : '',
    tradeTyp:  partner && typeof partner.tradeTyp === 'string'
    ? partner.tradeTyp.split(',').map(s => s.trim())
    : [],    // partner.tradeTyp이 없으면 빈 배열
    partnerNm: partner && partner.partnerNm !== null ? partner.partnerNm : '',
    loanAmt: partner && partner.loanAmt !== null ? partner.loanAmt : '0',
    regNumber: partner && partner.regNumber !== null ? partner.regNumber : '',
    partnerPhone:
      partner && partner.partnerPhone !== null ? partner.partnerPhone : '',
    partnerAddr:
      partner && partner.partnerAddr !== null ? partner.partnerAddr : '',
    partnerDesc:
      partner && partner.partnerDesc !== null ? partner.partnerDesc : '',
    president: partner && partner.president !== null ? partner.president : '',
    bankName: partner && partner.bankName !== null ? partner.bankName : '',
    accountNumber:
      partner && partner.accountNumber !== null ? partner.accountNumber : '',
    taxEmail: partner && partner.taxEmail !== null ? partner.taxEmail : '',
    taxContactNm:
      partner && partner.taxContactNm !== null ? partner.taxContactNm : '',
    taxContactPhone:
      partner && partner.taxContactPhone !== null
        ? partner.taxContactPhone
        : '',
  };

//  console.log(initialValues);

  const validationSchema = yup.object({
    partnerTyp: yup.string().required('거래처 종류를 선택하세요'),
    // 거래처코드는 신규 등록 시 사용자가 입력하지 않는다(서버가 관리 — KSM과 동일,
    // 업무 흐름 점검 2026-10-20 이슈 #1). 등록 화면에는 입력 UI가 없는데 필수로
    // 걸려 있어 저장이 조용히 막히던 원인이었다.
    partnerCd: yup.string().nullable(),
    incTyp: yup.string().required('산업체 유형을 선택하세요'),
    partnerNm: yup.string('').required('고객명을 입력하세요'),
    loanAmt: yup.string('').required('여신한도를 입력하세요'),
    regNumber: yup
      .string()
      .required('사업자번호를 입력하세요')
      .min(12, '사업자번호를 확인하세요')
      .max(12, '사업자번호를 확인하세요'),
    partnerPhone: yup.string().required('연락처를 입력하세요'),
    partnerAddr: yup.string('').required('주소를 입력하세요'),
    partnerDesc: yup.string().nullable(),
    president: yup.string().nullable(),
    bankName: yup.string().nullable(),
    accountNumber: yup.string().nullable(),
    taxEmail: yup
      .string()
      .nullable()
      .transform((value) => (value === '' ? null : value))
      .email('이메일 형식을 확인하세요'),
    taxContactNm: yup.string().nullable(),
    taxContactPhone: yup.string().nullable(),
//    tradeTyp: yup.array().min(1, '최소 한 개 이상 선택하세요.')

  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(type, values);
      formik.resetForm();
      setSubmitting(false);
    },
  });

  const onSave = (type, values) => {
    let dataToSubmit = {
      partnerTyp: values.partnerTyp,
      incTyp: values.incTyp,
      partnerNm: values.partnerNm.trim(),
      loanAmt: values.loanAmt || 0,
      regNumber: values.regNumber,
      tradeTyp: values.tradeTyp?.join(',') || '',  // 여기서만 문자열로 변환
      partnerPhone: values.partnerPhone,
      partnerAddr: values.partnerAddr,
      partnerDesc: values.partnerDesc,
      president: values.president,
      bankName: values.bankName,
      accountNumber: values.accountNumber,
      taxEmail: values.taxEmail,
      taxContactNm: values.taxContactNm,
      taxContactPhone: values.taxContactPhone,
    };
    // 거래처코드는 등록 시에는 보내지 않는다(위 스키마 주석 참고) — 수정 화면에서만
    // 기존 값을 함께 보낸다.
    if (type !== 'add') {
      dataToSubmit.partnerCd = values.partnerCd;
    }
    if (type === 'add') {
      client
        .post(`/api/v1/master/partner/info`, dataToSubmit)
        .then((res) => {
          if (res.data.result === 'success') {
            const partnerUuid = res.data?.info?.partnerUuid;
            enqueueSnackbar('거래처가 추가되었습니다', {
              variant: 'success',
            });

            if (shouldReturnToProjectForm && partnerUuid) {
              // 새 탭에서 등록한 경우 원래 탭(기회/프로젝트 폼)에 알려 자동 선택되게 하고
              // 이 탭은 닫는다. window.open으로 열리지 않은 탭(예: 직접 URL로 들어온 경우)은
              // window.close()가 동작하지 않을 수 있어 그때는 상세화면으로 이동한다.
              publishPartnerCreated({
                partner: {
                  ...res.data.info,
                  partnerUuid,
                  partnerNm: res.data.info?.partnerNm || dataToSubmit.partnerNm,
                },
                returnTo,
                returnToken,
              });

              setTimeout(() => {
                window.close();
                setTimeout(() => {
                  navigate(`/partnermng/${partnerUuid}`);
                }, 200);
              }, 200);
              return;
            }

            navigate(`/partnermng/${partnerUuid}`);
          } else {
            enqueueSnackbar(res.data?.message, {
              variant: 'error',
            });
          }
        })
        .catch((err) => {
          let message =
            typeof err.response !== 'undefined'
              ? err.response.data.message
              : err.message;
          enqueueSnackbar(message, {
            variant: 'error',
          });
        });
    } else {
      dataToSubmit.partnerUuid = partner.partnerUuid;

      client
        .put(`/api/v1/master/partner/info/${partner.partnerUuid}`, dataToSubmit)
        .then((res) => {
          dispatch(setPartner(res.data.info));
          enqueueSnackbar('거래처가 수정되었습니다', {
            variant: 'success',
          });
        })
        .catch((err) => {
          let message =
            typeof err.response !== 'undefined'
              ? err.response.data.message
              : err.message;
          enqueueSnackbar(message, {
            variant: 'error',
          });
        });
    }
  };

  return <PartnerForm formik={formik} type={type} />;
};

export default PartnerFormContainer;
